import _ from 'underscore';

export const isReportTemplateType = type => _.includes([
  'ReportUITemplate',
  'ReportUITemplateTest',
  'ReportUICustomerTemplate',
  'ReportUICustomerTemplateTest',
  'ReportUIAccountTemplate',
  'ReportUIAccountTemplateTest',
  'ReportUIUserTemplate',
  'ReportUIUserTemplateTest',
], type);
